import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* The ad composers' "Art style" and "Character" section bodies: the brand's active style as a small card (sample
   thumbnail, name, what it steers), a quiet link to the Art Style tab, and a "Drawn with" line for the selected
   version. Sized to sit in an IngredientSection body beside the subject card. */

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SPACE[12]};
`;

export const StyleCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[12]};
  align-self: stretch;
  padding: ${SPACE[12]};
  border-radius: 12px;
  background: ${COLORS.surfaceInset};
  border: 1px solid ${COLORS.hairline};
`;

export const Thumb = styled.img`
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
`;

/** Stands in for the thumbnail while the style has no sample or mood image (or it is still being read). */
export const ThumbFallback = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${COLORS.surfaceCard};
  border: 1px solid ${COLORS.hairline};
  color: ${COLORS.textMuted};
`;

export const StyleCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  min-width: 0;
`;

export const StyleName = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: ${COLORS.textBright};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyleNote = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 12px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;

export const Note = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 12px;
  line-height: 1.45;
  color: ${COLORS.textFaint};
`;

/** "Manage art style": a text link (leaves the composer for Website, Art Style; its edits are already saved). */
export const ManageLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[4]};
  padding: 0;
  border: none;
  background: transparent;
  font-size: 12.5px;
  font-weight: 600;
  color: ${COLORS.accent};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }

  svg {
    flex: none;
  }
`;

/** "Drawn with <style>": what the selected version's art was drawn with. */
export const DrawnWith = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  min-width: 0;
  max-width: 100%;
  font-size: 12px;
  line-height: 1.45;
  color: ${COLORS.textMuted};

  svg {
    flex: none;
  }
`;

export const DrawnWithText = styled(Text).attrs({ tag: 'span' as const })`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PickerRow = styled.div`
  display: flex;
  align-items: center;

  &:empty {
    display: none;
  }
`;
